import { useCallback, useState } from 'react';
import type { RemoteLinkGlobalId, ConfluenceWhiteboardId } from '@atlassian/jira-shared-types';

export const useConfirmationModalState = (
	handleDelete: (id: RemoteLinkGlobalId | ConfluenceWhiteboardId) => void,
) => {
	const [modalOpen, setModalOpen] = useState<boolean>(false);
	const [linkToDeleteId, setLinkToDeleteId] = useState<
		RemoteLinkGlobalId | RemoteLinkGlobalId | null
	>(null);

	const onConfirmDelete = useCallback(() => {
		if (linkToDeleteId != null) {
			handleDelete(linkToDeleteId);
		}
		setModalOpen(false);
		setLinkToDeleteId(null);
	}, [handleDelete, linkToDeleteId]);

	const onDeleteClick = useCallback((id: RemoteLinkGlobalId | ConfluenceWhiteboardId) => {
		setModalOpen(true);
		setLinkToDeleteId(id);
	}, []);

	const onCancelDelete = useCallback(() => {
		setModalOpen(false);
		setLinkToDeleteId(null);
	}, []);

	return {
		onDeleteClick,
		onConfirmDelete,
		onCancelDelete,
		modalOpen,
	};
};
